export const availableGenders = ['men', 'women', 'kids', 'unisex'];
